<template>
  <component :is="componentTag" />
</template>
<script>
import webAboutdpp from "./web";
import mobileAboutdpp from "./mobile";
export default {
  components: {
    webAboutdpp,
    mobileAboutdpp,
  },
  data() {
    return {
      isMobile: false,
      componentTag: "",
    };
  },
  created() {
    this.listenObserverWidth(750);
  },
  methods: {
    // 监听可视窗口宽度
    listenObserverWidth(mobileWidth) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentRect.width <= mobileWidth) {
            this.componentTag = "mobileAboutdpp";
          } else {
            this.componentTag = "webAboutdpp";
          }
        }
      });
      resizeObserver.observe(document.body);
    },
  },
};
</script>